import React from 'react';
import { useClient } from '../../context/ClientContext';

export default function ComingSoon() {
  const { brand } = useClient();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center max-w-md px-4">
        <div className="w-16 h-16 rounded-full mx-auto mb-6 flex items-center justify-center"
             style={{ backgroundColor: (brand.colors?.primary || '#2563eb') + '15' }}>
          <svg className="w-8 h-8" style={{ color: brand.colors?.primary || '#2563eb' }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2"
            style={{ fontFamily: brand.typography?.headerFont }}>
          Your dashboard is being set up
        </h1>
        <p className="text-gray-500 mb-6">
          We're building your custom Google Ads reporting dashboard. You'll receive access details from your account manager shortly.
        </p>
        <a
          href="mailto:chris@beechppc.com?subject=Dashboard%20access%20query"
          className="inline-block px-6 py-2.5 text-white rounded-lg text-sm font-medium transition-colors hover:opacity-90"
          style={{ backgroundColor: brand.colors?.primary || '#2563eb' }}
        >
          Contact your account manager
        </a>
      </div>
    </div>
  );
}
